import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import IndustryHero from "../../../../V2/Heroes/Content/IndustryHero"

import { storyblokLinkToYocoLink } from "@utils/storyblok"

const StoryblokContentIndustryHero = ({
  blok,
}: Storyblok.BlokProps<Storyblok.ContentIndustryHero>) => {
  return (
    <IndustryHero
      categoryIcon={blok.categoryIcon?.filename}
      categoryTitle={blok.categoryTitle}
      primaryBackgroundColor={blok.backgroundColor}
      secondaryBackgroundColor={blok.secondaryBackgroundColor}
      primaryButtonColor={blok.primaryCTAColor}
      bodyText={blok.bodyText}
      bodyHighlightedPhrase={blok.bodyHighlightedPhrase}
      headingText={blok.headingText}
      headingSize={blok.headingSize}
      headingMobileAlignment={blok.headingMobileAlignment}
      imageUrl={blok.image?.filename}
      imageAlt={blok.image?.alt}
      coverAssets={blok.coverAssets}
      videoUrl={
        blok.video?.filename ??
        storyblokLinkToYocoLink(blok.videoUrl)?.url ??
        ""
      }
      primaryButtonLink={storyblokLinkToYocoLink(blok.primaryCTALink)}
      primaryButtonMobileLink={storyblokLinkToYocoLink(
        blok.primaryCTAMobileLink
      )}
      primaryButtonText={blok.primaryCTAText}
      trackingEvent={blok.trackingEvent}
      trackingEventKey={blok.trackingEventKey}
      trackingEventValue={blok.trackingEventValue}
      secondaryButtonLink={storyblokLinkToYocoLink(blok.secondaryCTALink)}
      secondaryButtonText={blok.secondaryCTAText}
      secondaryCTATextColor={blok.secondaryCTATextColor}
      trustText={blok.trustText}
      trustCTAText={blok.trustCTAText}
      trustCTALink={storyblokLinkToYocoLink(blok.trustCTALink)}
      hasScrollArrow={blok.hasScrollArrow}
      hideMobileStickyButton={blok.hideMobileStickyButton}
      secondaryTrackingEvent={blok.secondaryTrackingEvent}
      secondaryTrackingEventKey={blok.secondaryTrackingEventKey}
      secondaryTrackingEventValue={blok.secondaryTrackingEventValue}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokContentIndustryHero
